var _slicedToArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _toConsumableArray = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");
var _classCallCheck = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var _createClass = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");
var _possibleConstructorReturn = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");
var _getPrototypeOf = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");
var _inherits = require("/home/circleci/project/web-front/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e8) { throw _e8; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e9) { didErr = true; err = _e9; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
!function (e) {
  var t = e.en = e.en || {};
  t.dictionary = Object.assign(t.dictionary || {}, {
    "Insert code block": "Insert code block",
    "Plain text": "Plain text"
  });
}(window.CKEDITOR_TRANSLATIONS || (window.CKEDITOR_TRANSLATIONS = {})),
/*!
 * @license Copyright (c) 2003-2022, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md.
 */
function () {
  var e = {
      67: function _(e, t, n) {
        "use strict";

        n.d(t, {
          Z: function Z() {
            return r;
          }
        });
        var o = n(609),
          i = n.n(o)()(function (e) {
            return e[1];
          });
        i.push([e.id, ".ck-content pre{padding:1em;color:#353535;background:hsla(0,0%,78%,.3);border:1px solid #c4c4c4;border-radius:2px;text-align:left;direction:ltr;tab-size:4;white-space:pre-wrap;font-style:normal;min-width:200px}.ck-content pre code{background:unset;padding:0;border-radius:0}.ck.ck-editor__editable pre{position:relative}.ck.ck-editor__editable pre[data-language]:after{content:attr(data-language);position:absolute}:root{--ck-color-code-block-label-background:#757575}.ck.ck-editor__editable pre[data-language]:after{top:-1px;right:10px;background:var(--ck-color-code-block-label-background);font-size:10px;font-family:var(--ck-font-face);line-height:16px;padding:var(--ck-spacing-tiny) var(--ck-spacing-medium);color:#fff;white-space:nowrap}.ck.ck-code-block-dropdown .ck-dropdown__panel{max-height:250px;overflow-y:auto;overflow-x:hidden}", ""]);
        var r = i;
      },
      609: function _(e) {
        "use strict";

        e.exports = function (e) {
          var t = [];
          return t.toString = function () {
            return this.map(function (t) {
              var n = e(t);
              return t[2] ? "@media ".concat(t[2], " {").concat(n, "}") : n;
            }).join("");
          }, t.i = function (e, n, o) {
            "string" == typeof e && (e = [[null, e, ""]]);
            var i = {};
            if (o) for (var r = 0; r < this.length; r++) {
              var a = this[r][0];
              null != a && (i[a] = !0);
            }
            for (var c = 0; c < e.length; c++) {
              var s = [].concat(e[c]);
              o && i[s[0]] || (n && (s[2] ? s[2] = "".concat(n, " and ").concat(s[2]) : s[2] = n), t.push(s));
            }
          }, t;
        };
      },
      62: function _(e, t, n) {
        "use strict";

        var o,
          i = function i() {
            return void 0 === o && (o = Boolean(window && document && document.all && !window.atob)), o;
          },
          r = function () {
            var e = {};
            return function (t) {
              if (void 0 === e[t]) {
                var n = document.querySelector(t);
                if (window.HTMLIFrameElement && n instanceof window.HTMLIFrameElement) try {
                  n = n.contentDocument.head;
                } catch (e) {
                  n = null;
                }
                e[t] = n;
              }
              return e[t];
            };
          }(),
          a = [];
        function c(e) {
          for (var t = -1, n = 0; n < a.length; n++) {
            if (a[n].identifier === e) {
              t = n;
              break;
            }
          }
          return t;
        }
        function s(e, t) {
          for (var n = {}, o = [], i = 0; i < e.length; i++) {
            var r = e[i],
              s = t.base ? r[0] + t.base : r[0],
              l = n[s] || 0,
              d = "".concat(s, " ").concat(l);
            n[s] = l + 1;
            var u = c(d),
              g = {
                css: r[1],
                media: r[2],
                sourceMap: r[3]
              };
            -1 !== u ? (a[u].references++, a[u].updater(g)) : a.push({
              identifier: d,
              updater: h(g, t),
              references: 1
            }), o.push(d);
          }
          return o;
        }
        function l(e) {
          var t = document.createElement("style"),
            o = e.attributes || {};
          if (void 0 === o.nonce) {
            var i = n.nc;
            i && (o.nonce = i);
          }
          if (Object.keys(o).forEach(function (e) {
            t.setAttribute(e, o[e]);
          }), "function" == typeof e.insert) e.insert(t);else {
            var a = r(e.insert || "head");
            if (!a) throw new Error("Couldn't find a style target. This probably means that the value for the 'insert' parameter is invalid.");
            a.appendChild(t);
          }
          return t;
        }
        var d,
          u = (d = [], function (e, t) {
            return d[e] = t, d.filter(Boolean).join("\n");
          });
        function g(e, t, n, o) {
          var i = n ? "" : o.media ? "@media ".concat(o.media, " {").concat(o.css, "}") : o.css;
          if (e.styleSheet) e.styleSheet.cssText = u(t, i);else {
            var r = document.createTextNode(i),
              a = e.childNodes;
            a[t] && e.removeChild(a[t]), a.length ? e.insertBefore(r, a[t]) : e.appendChild(r);
          }
        }
        function f(e, t, n) {
          var o = n.css,
            i = n.media,
            r = n.sourceMap;
          if (i ? e.setAttribute("media", i) : e.removeAttribute("media"), r && "undefined" != typeof btoa && (o += "\n/*# sourceMappingURL=data:application/json;base64,".concat(btoa(unescape(encodeURIComponent(JSON.stringify(r)))), " */")), e.styleSheet) e.styleSheet.cssText = o;else {
            for (; e.firstChild;) {
              e.removeChild(e.firstChild);
            }
            e.appendChild(document.createTextNode(o));
          }
        }
        var m = null,
          p = 0;
        function h(e, t) {
          var n, o, i;
          if (t.singleton) {
            var r = p++;
            n = m || (m = l(t)), o = g.bind(null, n, r, !1), i = g.bind(null, n, r, !0);
          } else n = l(t), o = f.bind(null, n, t), i = function i() {
            !function (e) {
              if (null === e.parentNode) return !1;
              e.parentNode.removeChild(e);
            }(n);
          };
          return o(e), function (t) {
            if (t) {
              if (t.css === e.css && t.media === e.media && t.sourceMap === e.sourceMap) return;
              o(e = t);
            } else i();
          };
        }
        e.exports = function (e, t) {
          (t = t || {}).singleton || "boolean" == typeof t.singleton || (t.singleton = i());
          var n = s(e = e || [], t);
          return function (e) {
            if (e = e || [], "[object Array]" === Object.prototype.toString.call(e)) {
              for (var o = 0; o < n.length; o++) {
                var i = c(n[o]);
                a[i].references--;
              }
              for (var r = s(e, t), l = 0; l < n.length; l++) {
                var d = c(n[l]);
                0 === a[d].references && (a[d].updater(), a.splice(d, 1));
              }
              n = r;
            }
          };
        };
      },
      704: function _(e, t, n) {
        e.exports = n(79)("./src/core.js");
      },
      492: function _(e, t, n) {
        e.exports = n(79)("./src/engine.js");
      },
      331: function _(e, t, n) {
        e.exports = n(79)("./src/enter.js");
      },
      273: function _(e, t, n) {
        e.exports = n(79)("./src/ui.js");
      },
      209: function _(e, t, n) {
        e.exports = n(79)("./src/utils.js");
      },
      79: function _(e) {
        "use strict";

        e.exports = CKEditor5.dll;
      }
    },
    t = {};
  function n(o) {
    var i = t[o];
    if (void 0 !== i) return i.exports;
    var r = t[o] = {
      id: o,
      exports: {}
    };
    return e[o](r, r.exports, n), r.exports;
  }
  n.n = function (e) {
    var t = e && e.__esModule ? function () {
      return e.default;
    } : function () {
      return e;
    };
    return n.d(t, {
      a: t
    }), t;
  }, n.d = function (e, t) {
    for (var o in t) {
      n.o(t, o) && !n.o(e, o) && Object.defineProperty(e, o, {
        enumerable: !0,
        get: t[o]
      });
    }
  }, n.o = function (e, t) {
    return Object.prototype.hasOwnProperty.call(e, t);
  }, n.r = function (e) {
    "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
      value: "Module"
    }), Object.defineProperty(e, "__esModule", {
      value: !0
    });
  };
  var o = {};
  (function () {
    "use strict";

    n.r(o), n.d(o, {
      CodeBlock: function CodeBlock() {
        return _;
      },
      CodeBlockEditing: function CodeBlockEditing() {
        return v;
      },
      CodeBlockUI: function CodeBlockUI() {
        return A;
      }
    });
    var e = n(704),
      t = n(331),
      i = n(492),
      r = n(209);
    function a(e) {
      var t = e.t,
        n = e.config.get("codeBlock.languages");
      var _iterator = _createForOfIteratorHelper(n),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _e = _step.value;
          "Plain text" === _e.label && (_e.label = t("Plain text")), void 0 === _e.class && (_e.class = "language-".concat(_e.language));
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      return n;
    }
    function c(e, t, n) {
      var o = {};
      var _iterator2 = _createForOfIteratorHelper(e),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _i = _step2.value;
          "class" === t ? o[_i[t].split(" ").shift()] = _i[n] : o[_i[t]] = _i[n];
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      return o;
    }
    function s(e) {
      return e.data.match(/^(\s*)/)[0];
    }
    function l(e) {
      var t = e.document.selection,
        n = [];
      if (t.isCollapsed) n.push(t.anchor);else {
        var _o = t.getFirstRange().getWalker({
          ignoreElementEnd: !0,
          direction: "backward"
        });
        var _iterator3 = _createForOfIteratorHelper(_o),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _t = _step3.value.item;
            if (_t.is("$textProxy") && _t.parent.is("element", "codeBlock")) {
              var _o2 = s(_t.textNode),
                _t$textNode = _t.textNode,
                _i2 = _t$textNode.parent,
                _r = _t$textNode.startOffset,
                _a = e.createPositionAt(_i2, _r + _o2.length);
              n.push(_a);
            }
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
      return n;
    }
    function d(e) {
      var t = (0, r.first)(e.getSelectedBlocks());
      return t && t.is("element", "codeBlock");
    }
    var u = /*#__PURE__*/function (_e$Command) {
      _inherits(u, _e$Command);
      function u(e) {
        var _this;
        _classCallCheck(this, u);
        _this = _possibleConstructorReturn(this, _getPrototypeOf(u).call(this, e)), _this._lastLanguage = null;
        return _this;
      }
      _createClass(u, [{
        key: "refresh",
        value: function refresh() {
          this.value = this._getValue(), this.isEnabled = this._checkEnabled();
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this2 = this;
          var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
          var t = this.editor,
            n = t.model,
            o = n.document.selection,
            i = a(t)[0],
            r = Array.from(o.getSelectedBlocks()),
            c = void 0 === e.forceValue ? !this.value : e.forceValue,
            s = function (e, t, n) {
              if (e.language) return e.language;
              if (e.usePreviousLanguageChoice && t) return t;
              return n;
            }(e, this._lastLanguage, i.language);
          n.change(function (e) {
            c ? _this2._applyCodeBlock(e, r, s) : _this2._removeCodeBlock(e, r);
          });
        }
      }, {
        key: "_getValue",
        value: function _getValue() {
          var e = this.editor.model.document.selection,
            t = (0, r.first)(e.getSelectedBlocks());
          return !!!(!t || !t.is("element", "codeBlock")) && t.getAttribute("language");
        }
      }, {
        key: "_checkEnabled",
        value: function _checkEnabled() {
          if (this.value) return !0;
          var e = this.editor.model.document.selection,
            t = this.editor.model.schema,
            n = (0, r.first)(e.getSelectedBlocks());
          return !!n && g(t, n);
        }
      }, {
        key: "_applyCodeBlock",
        value: function _applyCodeBlock(e, t, n) {
          this._lastLanguage = n;
          var o = this.editor.model.schema,
            i = t.filter(function (e) {
              return g(o, e);
            });
          var _iterator4 = _createForOfIteratorHelper(i),
            _step4;
          try {
            var _loop = function _loop() {
              var t = _step4.value;
              e.rename(t, "codeBlock"), e.setAttribute("language", n, t), o.removeDisallowedAttributes([t], e), Array.from(t.getChildren()).filter(function (e) {
                return !o.checkChild(t, e);
              }).forEach(function (t) {
                return e.remove(t);
              });
            };
            for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
              _loop();
            }
          } catch (err) {
            _iterator4.e(err);
          } finally {
            _iterator4.f();
          }
          i.reverse().forEach(function (t, n) {
            var o = i[n + 1];
            t.previousSibling === o && (e.appendElement("softBreak", o), e.merge(e.createPositionBefore(t)));
          });
        }
      }, {
        key: "_removeCodeBlock",
        value: function _removeCodeBlock(e, t) {
          var n = t.filter(function (e) {
            return e.is("element", "codeBlock");
          });
          var _iterator5 = _createForOfIteratorHelper(n),
            _step5;
          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var _t2 = _step5.value;
              var _n = e.createRangeOn(_t2);
              var _iterator6 = _createForOfIteratorHelper(Array.from(_n.getItems()).reverse()),
                _step6;
              try {
                for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                  var _t3 = _step6.value;
                  if (_t3.is("element", "softBreak") && _t3.parent.is("element", "codeBlock")) {
                    var _e$split = e.split(e.createPositionBefore(_t3)),
                      _n2 = _e$split.position;
                    e.rename(_n2.nodeAfter, "paragraph"), e.removeAttribute("language", _n2.nodeAfter), e.remove(_t3);
                  }
                }
              } catch (err) {
                _iterator6.e(err);
              } finally {
                _iterator6.f();
              }
              e.rename(_t2, "paragraph"), e.removeAttribute("language", _t2);
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        }
      }]);
      return u;
    }(e.Command);
    function g(e, t) {
      return !t.is("rootElement") && !e.isLimit(t) && e.checkChild(t.parent, "codeBlock");
    }
    var f = /*#__PURE__*/function (_e$Command2) {
      _inherits(f, _e$Command2);
      function f(e) {
        var _this3;
        _classCallCheck(this, f);
        _this3 = _possibleConstructorReturn(this, _getPrototypeOf(f).call(this, e)), _this3._indentSequence = e.config.get("codeBlock.indentSequence");
        return _this3;
      }
      _createClass(f, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = this._checkEnabled();
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this4 = this;
          var e = this.editor.model;
          e.change(function (t) {
            var n = l(e);
            var _iterator7 = _createForOfIteratorHelper(n),
              _step7;
            try {
              for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
                var _e2 = _step7.value;
                t.insertText(_this4._indentSequence, _e2);
              }
            } catch (err) {
              _iterator7.e(err);
            } finally {
              _iterator7.f();
            }
          });
        }
      }, {
        key: "_checkEnabled",
        value: function _checkEnabled() {
          return !!this._indentSequence && d(this.editor.model.document.selection);
        }
      }]);
      return f;
    }(e.Command);
    var m = /*#__PURE__*/function (_e$Command3) {
      _inherits(m, _e$Command3);
      function m(e) {
        var _this5;
        _classCallCheck(this, m);
        _this5 = _possibleConstructorReturn(this, _getPrototypeOf(m).call(this, e)), _this5._indentSequence = e.config.get("codeBlock.indentSequence");
        return _this5;
      }
      _createClass(m, [{
        key: "refresh",
        value: function refresh() {
          this.isEnabled = this._checkEnabled();
        }
      }, {
        key: "execute",
        value: function execute() {
          var _this6 = this;
          var e = this.editor.model;
          e.change(function (t) {
            var n = l(e);
            var _iterator8 = _createForOfIteratorHelper(n),
              _step8;
            try {
              for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
                var _e3 = _step8.value;
                var _n3 = p(_this6.editor.model, _e3, _this6._indentSequence);
                _n3 && t.remove(_n3);
              }
            } catch (err) {
              _iterator8.e(err);
            } finally {
              _iterator8.f();
            }
          });
        }
      }, {
        key: "_checkEnabled",
        value: function _checkEnabled() {
          var _this7 = this;
          if (!this._indentSequence) return !1;
          var e = this.editor.model;
          return !!d(e.document.selection) && l(e).some(function (t) {
            return p(e, t, _this7._indentSequence);
          });
        }
      }]);
      return m;
    }(e.Command);
    function p(e, t, n) {
      var o = function (e) {
        var t = e.parent.getChild(e.index);
        t && !t.is("element", "softBreak") || (t = e.nodeBefore);
        if (!t || t.is("element", "softBreak")) return null;
        return t;
      }(t);
      if (!o) return null;
      var i = s(o),
        r = i.lastIndexOf(n);
      if (r + n.length !== i.length) return null;
      if (-1 === r) return null;
      var a = o.parent,
        c = o.startOffset;
      return e.createRange(e.createPositionAt(a, c + r), e.createPositionAt(a, c + r + n.length));
    }
    function h(e, t) {
      var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : !1;
      var o = c(t, "language", "class"),
        i = c(t, "language", "label");
      return function (t, r, a) {
        var c = a.writer,
          s = a.mapper,
          l = a.consumable;
        if (!l.consume(r.item, "insert")) return;
        var d = r.item.getAttribute("language"),
          u = s.toViewPosition(e.createPositionBefore(r.item)),
          g = {};
        n && (g["data-language"] = i[d], g.spellcheck = "false");
        var f = c.createContainerElement("code", {
            class: o[d] || null
          }),
          m = c.createContainerElement("pre", g, f);
        c.insert(u, m), s.bindElements(r.item, f);
      };
    }
    var b = "paragraph";
    var v = /*#__PURE__*/function (_e$Plugin) {
      _inherits(v, _e$Plugin);
      _createClass(v, null, [{
        key: "pluginName",
        get: function get() {
          return "CodeBlockEditing";
        }
      }, {
        key: "requires",
        get: function get() {
          return [t.ShiftEnter];
        }
      }]);
      function v(e) {
        var _this8;
        _classCallCheck(this, v);
        _this8 = _possibleConstructorReturn(this, _getPrototypeOf(v).call(this, e)), e.config.define("codeBlock", {
          languages: [{
            language: "plaintext",
            label: "Plain text"
          }, {
            language: "c",
            label: "C"
          }, {
            language: "cs",
            label: "C#"
          }, {
            language: "cpp",
            label: "C++"
          }, {
            language: "css",
            label: "CSS"
          }, {
            language: "diff",
            label: "Diff"
          }, {
            language: "html",
            label: "HTML"
          }, {
            language: "java",
            label: "Java"
          }, {
            language: "javascript",
            label: "JavaScript"
          }, {
            language: "php",
            label: "PHP"
          }, {
            language: "python",
            label: "Python"
          }, {
            language: "ruby",
            label: "Ruby"
          }, {
            language: "typescript",
            label: "TypeScript"
          }, {
            language: "xml",
            label: "XML"
          }],
          indentSequence: "\t"
        });
        return _this8;
      }
      _createClass(v, [{
        key: "init",
        value: function init() {
          var _this9 = this;
          var e = this.editor,
            t = e.model.schema,
            n = e.model,
            o = (e.editing.view, a(e));
          e.commands.add("codeBlock", new u(e)), e.commands.add("indentCodeBlock", new f(e)), e.commands.add("outdentCodeBlock", new m(e));
          var r = function r(e) {
            return function (t, n) {
              _this9.editor.commands.get(e).isEnabled && (_this9.editor.execute(e), n());
            };
          };
          e.keystrokes.set("Tab", r("indentCodeBlock")), e.keystrokes.set("Shift+Tab", r("outdentCodeBlock")), t.register("codeBlock", {
            allowWhere: "$block",
            allowChildren: "$text",
            isBlock: !0,
            allowAttributes: ["language"]
          }), t.addAttributeCheck(function (e) {
            if (e.endsWith("codeBlock $text")) return !1;
          }), e.model.schema.addChildCheck(function (e, t) {
            if (e.endsWith("codeBlock") && t.isObject) return !1;
          }), e.editing.downcastDispatcher.on("insert:codeBlock", h(n, o, !0)), e.data.downcastDispatcher.on("insert:codeBlock", h(n, o)), e.data.downcastDispatcher.on("insert:softBreak", function (e) {
            return function (t, n, o) {
              if ("codeBlock" !== n.item.parent.name) return;
              var i = o.writer,
                r = o.mapper,
                a = o.consumable;
              if (!a.consume(n.item, "insert")) return;
              var c = r.toViewPosition(e.createPositionBefore(n.item));
              i.insert(c, i.createText("\n"));
            };
          }(n), {
            priority: "high"
          }), e.data.upcastDispatcher.on("element:code", function (e, t) {
            var n = c(t, "class", "language"),
              o = t[0].language;
            return function (e, t, i) {
              var r = t.viewItem,
                a = r.parent;
              if (!a || !a.is("element", "pre")) return;
              if (t.modelCursor.findAncestor("codeBlock")) return;
              var c = i.consumable,
                s = i.writer;
              if (!c.test(r, {
                name: !0
              })) return;
              var l = s.createElement("codeBlock"),
                d = _toConsumableArray(r.getClassNames());
              d.length || d.push("");
              var _iterator9 = _createForOfIteratorHelper(d),
                _step9;
              try {
                for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
                  var _e4 = _step9.value;
                  var _t4 = n[_e4];
                  if (_t4) {
                    s.setAttribute("language", _t4, l);
                    break;
                  }
                }
              } catch (err) {
                _iterator9.e(err);
              } finally {
                _iterator9.f();
              }
              l.hasAttribute("language") || s.setAttribute("language", o, l), i.convertChildren(r, l), i.safeInsert(l, t.modelCursor) && (c.consume(r, {
                name: !0
              }), i.updateConversionResult(l, t));
            };
          }(0, o)), e.data.upcastDispatcher.on("text", function (e, t, _ref) {
            var n = _ref.consumable,
              o = _ref.writer;
            var i = t.modelCursor;
            if (!n.test(t.viewItem)) return;
            if (!i.findAncestor("codeBlock")) return;
            n.consume(t.viewItem);
            var r = t.viewItem.data.split("\n").map(function (e) {
                return o.createText(e);
              }),
              a = r[r.length - 1];
            var _iterator10 = _createForOfIteratorHelper(r),
              _step10;
            try {
              for (_iterator10.s(); !(_step10 = _iterator10.n()).done;) {
                var _e5 = _step10.value;
                if (o.insert(_e5, i), i = i.getShiftedBy(_e5.offsetSize), _e5 !== a) {
                  var _e6 = o.createElement("softBreak");
                  o.insert(_e6, i), i = o.createPositionAfter(_e6);
                }
              }
            } catch (err) {
              _iterator10.e(err);
            } finally {
              _iterator10.f();
            }
            t.modelRange = o.createRange(t.modelCursor, i), t.modelCursor = i;
          }), this.listenTo(e.editing.view.document, "clipboardInput", function (t, o) {
            var r = n.createRange(n.document.selection.anchor);
            if (o.targetRanges && (r = e.editing.mapper.toModelRange(o.targetRanges[0])), !r.start.parent.is("element", "codeBlock")) return;
            var a = o.dataTransfer.getData("text/plain"),
              c = new i.UpcastWriter(e.editing.view.document);
            o.content = function (e, t) {
              var n = e.createDocumentFragment(),
                o = t.split("\n"),
                i = o.reduce(function (t, n, i) {
                  return t.push(n), i < o.length - 1 && t.push(e.createElement("br")), t;
                }, []);
              return e.appendChild(i, n), n;
            }(c, a);
          }), this.listenTo(n, "getSelectedContent", function (e, _ref2) {
            var _ref3 = _slicedToArray(_ref2, 1),
              o = _ref3[0];
            var i = o.anchor;
            !o.isCollapsed && i.parent.is("element", "codeBlock") && i.hasSameParentAs(o.focus) && n.change(function (n) {
              var r = e.return;
              if (r.childCount > 1 || o.containsEntireContent(i.parent)) {
                var _t5 = n.createElement("codeBlock", i.parent.getAttributes());
                n.append(r, _t5);
                var _o3 = n.createDocumentFragment();
                n.append(_t5, _o3), e.return = _o3;
              } else {
                var _e7 = r.getChild(0);
                t.checkAttribute(_e7, "code") && n.setAttribute("code", !0, _e7);
              }
            });
          });
        }
      }, {
        key: "afterInit",
        value: function afterInit() {
          var e = this.editor,
            t = e.commands,
            n = t.get("indent"),
            o = t.get("outdent");
          n && n.registerChildCommand(t.get("indentCodeBlock")), o && o.registerChildCommand(t.get("outdentCodeBlock")), this.listenTo(e.editing.view.document, "enter", function (t, n) {
            e.model.document.selection.getLastPosition().parent.is("element", "codeBlock") && (function (e, t) {
              var n = e.model.document,
                o = e.editing.view,
                i = n.selection.getLastPosition(),
                r = i.nodeAfter;
              if (t || !n.selection.isCollapsed || !i.isAtStart) return !1;
              if (!B(r)) return !1;
              return e.model.change(function (t) {
                e.execute("enter");
                var o = n.selection.anchor.parent.previousSibling;
                t.rename(o, b), t.setSelection(o, "in"), e.model.schema.removeDisallowedAttributes([o], t), t.remove(r);
              }), o.scrollToTheSelection(), !0;
            }(e, n.isSoft) || function (e, t) {
              var n = e.model,
                o = n.document,
                i = e.editing.view,
                r = o.selection.getLastPosition(),
                a = r.nodeBefore;
              var c;
              if (t || !o.selection.isCollapsed || !r.isAtEnd || !a || !a.previousSibling) return !1;
              if (B(a) && B(a.previousSibling)) c = n.createRange(n.createPositionBefore(a.previousSibling), n.createPositionAfter(a));else if (k(a) && B(a.previousSibling) && B(a.previousSibling.previousSibling)) c = n.createRange(n.createPositionBefore(a.previousSibling.previousSibling), n.createPositionAfter(a));else {
                if (!(k(a) && B(a.previousSibling) && k(a.previousSibling.previousSibling) && B(a.previousSibling.previousSibling.previousSibling))) return !1;
                c = n.createRange(n.createPositionBefore(a.previousSibling.previousSibling.previousSibling), n.createPositionAfter(a));
              }
              return e.model.change(function (t) {
                t.remove(c), e.execute("enter");
                var n = o.selection.anchor.parent;
                t.rename(n, b), e.model.schema.removeDisallowedAttributes([n], t);
              }), i.scrollToTheSelection(), !0;
            }(e, n.isSoft) || function (e) {
              var t = e.model.document,
                n = t.selection.getLastPosition(),
                o = n.nodeBefore || n.textNode;
              var i;
              o && o.is("$text") && (i = s(o));
              e.model.change(function (n) {
                e.execute("shiftEnter"), i && n.insertText(i, t.selection.anchor);
              });
            }(e), n.preventDefault(), t.stop());
          }, {
            context: "pre"
          });
        }
      }]);
      return v;
    }(e.Plugin);
    function k(e) {
      return e && e.is("$text") && !e.data.match(/\S/);
    }
    function B(e) {
      return e && e.is("element", "softBreak");
    }
    var w = n(273);
    var x = n(62),
      C = n.n(x),
      S = n(67),
      y = {
        injectType: "singletonStyleTag",
        attributes: {
          "data-cke": !0
        },
        insert: "head",
        singleton: !0
      };
    C()(S.Z, y);
    S.Z.locals;
    var A = /*#__PURE__*/function (_e$Plugin2) {
      _inherits(A, _e$Plugin2);
      function A() {
        _classCallCheck(this, A);
        return _possibleConstructorReturn(this, _getPrototypeOf(A).apply(this, arguments));
      }
      _createClass(A, [{
        key: "init",
        value: function init() {
          var _this10 = this;
          var e = this.editor,
            t = e.t,
            n = e.ui.componentFactory,
            o = a(e);
          n.add("codeBlock", function (n) {
            var i = e.commands.get("codeBlock"),
              r = (0, w.createDropdown)(n, w.SplitButtonView),
              a = r.buttonView;
            return a.set({
              label: t("Insert code block"),
              tooltip: !0,
              icon: '<svg viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path d="M12.87 12.61a.75.75 0 0 1-.089.976l-.085.07-3.154 2.254 3.412 2.414a.75.75 0 0 1 .237.95l-.057.095a.75.75 0 0 1-.95.237l-.096-.058-4.272-3.022-.003-1.223 4.01-2.867a.75.75 0 0 1 1.047.174zm2.795-.231.095.057 4.011 2.867-.003 1.223-4.272 3.022-.095.058a.75.75 0 0 1-.88-.151l-.07-.086-.058-.095a.75.75 0 0 1 .15-.88l.087-.07 3.412-2.414-3.154-2.253-.085-.071a.75.75 0 0 1 .862-1.207zM16 0a2 2 0 0 1 2 2v9.354l-.663-.492-.837-.001V2a.5.5 0 0 0-.5-.5H2a.5.5 0 0 0-.5.5v15a.5.5 0 0 0 .5.5h3.118L7.156 19H2a2 2 0 0 1-2-2V2a2 2 0 0 1 2-2h14zM5.009 15l.003 1H3v-1h2.009zm2.188-2-1.471 1H5v-1h2.197zM10 11v.095L8.668 12H7v-1h3zm4-2v1H7V9h7zm0-2v1H7V7h7zm-4-2v1H5V5h5zM6 3v1H3V3h3z"/></svg>',
              isToggleable: !0
            }), a.bind("isOn").to(i, "value", function (e) {
              return !!e;
            }), a.on("execute", function () {
              e.execute("codeBlock", {
                usePreviousLanguageChoice: !0
              }), e.editing.view.focus();
            }), r.on("execute", function (t) {
              e.execute("codeBlock", {
                language: t.source._codeBlockLanguage,
                forceValue: !0
              }), e.editing.view.focus();
            }), r.class = "ck-code-block-dropdown", r.bind("isEnabled").to(i), (0, w.addListToDropdown)(r, _this10._getLanguageListItemDefinitions(o)), r;
          });
        }
      }, {
        key: "_getLanguageListItemDefinitions",
        value: function _getLanguageListItemDefinitions(e) {
          var t = this.editor.commands.get("codeBlock"),
            n = new r.Collection();
          var _iterator11 = _createForOfIteratorHelper(e),
            _step11;
          try {
            var _loop2 = function _loop2() {
              var o = _step11.value;
              var e = {
                type: "button",
                model: new w.Model({
                  _codeBlockLanguage: o.language,
                  label: o.label,
                  withText: !0
                })
              };
              e.model.bind("isOn").to(t, "value", function (t) {
                return t === e.model._codeBlockLanguage;
              }), n.add(e);
            };
            for (_iterator11.s(); !(_step11 = _iterator11.n()).done;) {
              _loop2();
            }
          } catch (err) {
            _iterator11.e(err);
          } finally {
            _iterator11.f();
          }
          return n;
        }
      }], [{
        key: "pluginName",
        get: function get() {
          return "CodeBlockUI";
        }
      }]);
      return A;
    }(e.Plugin);
    var _ = /*#__PURE__*/function (_e$Plugin3) {
      _inherits(_, _e$Plugin3);
      function _() {
        _classCallCheck(this, _);
        return _possibleConstructorReturn(this, _getPrototypeOf(_).apply(this, arguments));
      }
      _createClass(_, null, [{
        key: "requires",
        get: function get() {
          return [v, A];
        }
      }, {
        key: "pluginName",
        get: function get() {
          return "CodeBlock";
        }
      }]);
      return _;
    }(e.Plugin);
  })(), (window.CKEditor5 = window.CKEditor5 || {}).codeBlock = o;
}();